export default __webpack_public_path__ + "static/media/pin-resume.ab4c6a9d.svg";